import React from "react";
import { createRoot } from "react-dom/client";
import "./normalize.css";
import './initScript';
import Component from './component';
import './styles/global.scss';

const dom = document.querySelector("#root");
const root = createRoot(dom);
root.render(<Component />);
